<div class="sidebar-profile">
  <!-- Loading State -->
  @if (loading) {
    <div class="sidebar-loading">
      <mat-spinner diameter="32"></mat-spinner>
      <div class="loading-text">Carregando...</div>
    </div>
  }

  <!-- Error State -->
  @if (error && !loading) {
    <div class="sidebar-error">
      <mat-icon class="error-icon">error</mat-icon>
      <div class="error-text">Erro ao carregar dados</div>
      <button mat-icon-button (click)="loadUserProfile()" class="retry-button">
        <mat-icon>refresh</mat-icon>
      </button>
    </div>
  }

  <!-- User Profile Content -->
  @if (!loading && !error) {
    <div class="sidebar-avatar">
      @if (getDisplayPhoto()) {
        <img [src]="getDisplayPhoto()" [alt]="getDisplayName()" class="user-photo">
      } @else {
        <mat-icon>account_circle</mat-icon>
      }
    </div>
    <div class="sidebar-name">{{ getDisplayName() }}</div>
    <div class="sidebar-email">{{ getDisplayEmail() }}</div>
  }
</div>
<!-- <mat-divider></mat-divider> -->
<mat-nav-list>
  @for (item of menuItems; track item.label) {
    <a mat-list-item
       [class.selected]="isItemSelected(item)"
       [class.external-link]="isExternalLink(item)"
       (click)="onMenuItemClick(item)">
      <mat-icon matListItemIcon>{{item.icon}}</mat-icon>
      <span matListItemTitle>{{ item.label }}</span>
      @if (isExternalLink(item)) {
        <mat-icon class="external-icon">open_in_new</mat-icon>
      }
    </a>
  }
</mat-nav-list>
